/**
 * Baby On — galería compacta y visualizador de producto
 * Debutify 3.0.2 / 30-jul-2026
 *
 * - En escritorio recrea los carruseles para usar miniaturas verticales.
 * - En tablet y móvil conserva las miniaturas horizontales.
 * - Al pulsar una imagen principal abre un visualizador de pantalla completa
 *   con navegación, zoom, rueda del mouse, teclado y arrastre táctil.
 */
(function (window, document) {
  'use strict';

  var DESKTOP_BREAKPOINT = 1024;
  var RESIZE_DELAY = 180;
  var resizeTimer = null;
  var runTimer = null;
  var galleryGesture = null;

  function getJQuery() {
    return window.jQuery || window.$;
  }

  function isDesktop() {
    return window.matchMedia
      ? window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)').matches
      : window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function safeCurrentSlide($slider) {
    if (!$slider || !$slider.length) return 0;

    if ($slider.hasClass('slick-initialized')) {
      try {
        return Number($slider.slick('slickCurrentSlide')) || 0;
      } catch (error) {
        return 0;
      }
    }

    var featuredIndex = $slider
      .find('[data-product-single-media-wrapper].featured-media')
      .closest('[data-product-single-media-flex-wrapper]')
      .index();

    return featuredIndex >= 0 ? featuredIndex : 0;
  }

  function destroyCarousel($slider) {
    if (!$slider || !$slider.length) return;

    $slider.off('.boProductCompact');

    if ($slider.hasClass('slick-initialized')) {
      try {
        $slider.slick('unslick');
      } catch (error) {
        // Si otra aplicación ya lo destruyó, continuamos sin interrumpir la página.
      }
    }

    $slider.removeClass('slick-fallback bo-product-main--vertical bo-product-thumbs--vertical');
  }

  function unveilImages($root) {
    if (!window.lazySizes || !window.lazySizes.loader) return;

    $root.find('img.lazyload').each(function () {
      try {
        window.lazySizes.loader.unveil(this);
      } catch (error) {
        // LazySizes puede estar procesando el mismo elemento simultáneamente.
      }
    });
  }

  function initProductSection(sectionRoot) {
    var $ = getJQuery();
    if (!$ || !$.fn || typeof $.fn.slick !== 'function') return;

    var $section = $(sectionRoot);
    var $main = $section.find('[data-product-single-media-group]').first();
    var $thumbs = $section.find('[data-product-thumbnails]').first();

    if (!$main.length || !$thumbs.length) return;

    // El diseño Stacked de Debutify tiene otra lógica y no se fuerza.
    if (String($section.attr('data-stacked-layout')) === 'true') return;

    var mediaCount = $main.find('[data-product-single-media-flex-wrapper]').length;
    var thumbCount = $thumbs.find('[data-product-thumbnail-wrapper]').length;

    if (mediaCount < 2 || thumbCount < 2) return;

    var currentSlide = Math.min(safeCurrentSlide($main), mediaCount - 1);
    var desktop = isDesktop();
    var desiredMode = desktop ? 'desktop' : 'mobile';
    var thumbSlides = Math.min(5, thumbCount);

    // No recrear carruseles si ya tienen la orientación correcta.
    if (
      $section.attr('data-bo-compact-gallery') === desiredMode &&
      $main.hasClass('slick-initialized') &&
      $thumbs.hasClass('slick-initialized')
    ) {
      try {
        $thumbs.slick('setPosition');
        $main.slick('setPosition');
        return;
      } catch (error) {
        // Si Shopify acaba de reemplazar la sección, se reconstruye abajo.
      }
    }

    destroyCarousel($main);
    destroyCarousel($thumbs);

    // Se inicializan primero las miniaturas, igual que en Debutify.
    $thumbs
      .on('init.boProductCompact reInit.boProductCompact', function () {
        unveilImages($thumbs);
      })
      .slick({
        slidesToShow: thumbSlides,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        focusOnSelect: true,
        asNavFor: $main,
        swipeToSlide: true,
        infinite: false,
        speed: (window.theme && window.theme.variables && window.theme.variables.transitionSpeed) || 300,
        initialSlide: currentSlide,
        vertical: desktop,
        verticalSwiping: desktop,
        adaptiveHeight: false
      });

    $main
      .on('init.boProductCompact reInit.boProductCompact', function () {
        unveilImages($main);
      })
      .on('afterChange.boProductCompact', function (event, slick, index) {
        var $allThumbs = $thumbs.find('[data-product-thumbnail]');
        $allThumbs.removeClass('active-thumb');
        $allThumbs.eq(index).addClass('active-thumb');
      })
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        focusOnSelect: false,
        asNavFor: $thumbs,
        infinite: false,
        speed: (window.theme && window.theme.variables && window.theme.variables.transitionSpeed) || 300,
        initialSlide: currentSlide,
        adaptiveHeight: false
      });

    $section.attr('data-bo-compact-gallery', desiredMode);
    $thumbs.toggleClass('bo-product-thumbs--vertical', desktop);
    $main.toggleClass('bo-product-main--vertical', desktop);

    // Asegura medidas correctas después de cargar fuentes e imágenes.
    window.requestAnimationFrame(function () {
      try {
        $thumbs.slick('setPosition');
        $main.slick('setPosition');
        $main.slick('slickGoTo', currentSlide, true);
      } catch (error) {
        // La sección pudo haber sido retirada por el editor de temas.
      }
    });
  }

  function initAllProductSections() {
    var sections = document.querySelectorAll('[data-section-type="product-template"]');
    for (var i = 0; i < sections.length; i += 1) {
      initProductSection(sections[i]);
    }
  }

  function scheduleInit(delay) {
    window.clearTimeout(runTimer);
    runTimer = window.setTimeout(initAllProductSections, typeof delay === 'number' ? delay : 40);
  }

  /* -----------------------------------------------------------------------
     Visualizador de imágenes
     ----------------------------------------------------------------------- */
  var lightbox = {
    root: null,
    stage: null,
    image: null,
    closeButton: null,
    previousButton: null,
    nextButton: null,
    zoomOutButton: null,
    zoomInButton: null,
    counter: null,
    items: [],
    index: 0,
    scale: 1,
    translateX: 0,
    translateY: 0,
    trigger: null,
    pointers: {},
    gesture: null,
    isOpen: false
  };

  function createButton(className, label, symbol) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bo-product-lightbox__button ' + className;
    button.setAttribute('aria-label', label);
    button.textContent = symbol;
    return button;
  }

  function buildLightbox() {
    if (lightbox.root) return;

    var root = document.createElement('div');
    root.className = 'bo-product-lightbox';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Visualizador de imágenes del producto');
    root.setAttribute('aria-hidden', 'true');

    var stage = document.createElement('div');
    stage.className = 'bo-product-lightbox__stage';

    var image = document.createElement('img');
    image.className = 'bo-product-lightbox__image';
    image.alt = '';
    image.draggable = false;
    stage.appendChild(image);

    var toolbar = document.createElement('div');
    toolbar.className = 'bo-product-lightbox__toolbar';

    var counter = document.createElement('span');
    counter.className = 'bo-product-lightbox__counter';
    counter.setAttribute('aria-live', 'polite');

    var zoomOutButton = createButton('bo-product-lightbox__zoom-out', 'Alejar imagen', '−');
    var zoomInButton = createButton('bo-product-lightbox__zoom-in', 'Acercar imagen', '+');
    var closeButton = createButton('bo-product-lightbox__close', 'Cerrar visualizador', '×');

    toolbar.appendChild(counter);
    toolbar.appendChild(zoomOutButton);
    toolbar.appendChild(zoomInButton);
    toolbar.appendChild(closeButton);

    var previousButton = createButton(
      'bo-product-lightbox__nav bo-product-lightbox__prev',
      'Imagen anterior',
      '‹'
    );
    var nextButton = createButton(
      'bo-product-lightbox__nav bo-product-lightbox__next',
      'Imagen siguiente',
      '›'
    );

    var hint = document.createElement('p');
    hint.className = 'bo-product-lightbox__hint';
    hint.textContent = 'Rueda del mouse o botones para hacer zoom';

    root.appendChild(stage);
    root.appendChild(toolbar);
    root.appendChild(previousButton);
    root.appendChild(nextButton);
    root.appendChild(hint);
    document.body.appendChild(root);

    lightbox.root = root;
    lightbox.stage = stage;
    lightbox.image = image;
    lightbox.closeButton = closeButton;
    lightbox.previousButton = previousButton;
    lightbox.nextButton = nextButton;
    lightbox.zoomOutButton = zoomOutButton;
    lightbox.zoomInButton = zoomInButton;
    lightbox.counter = counter;

    closeButton.addEventListener('click', closeLightbox);
    previousButton.addEventListener('click', function () {
      showLightboxItem(lightbox.index - 1);
    });
    nextButton.addEventListener('click', function () {
      showLightboxItem(lightbox.index + 1);
    });
    zoomOutButton.addEventListener('click', function () {
      setLightboxScale(lightbox.scale - 0.5, null, null, true);
    });
    zoomInButton.addEventListener('click', function () {
      setLightboxScale(lightbox.scale + 0.5, null, null, true);
    });

    image.addEventListener('load', function () {
      image.classList.remove('is-loading');
      clampLightboxTranslation();
      applyLightboxTransform();
    });

    image.addEventListener('error', function () {
      image.classList.remove('is-loading');
    });

    image.addEventListener('click', function (event) {
      // Al pulsar la imagen dentro del visualizador no se cierra.
      event.stopPropagation();
    });

    image.addEventListener('dblclick', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setLightboxScale(lightbox.scale > 1 ? 1 : 2, event.clientX, event.clientY, true);
    });

    stage.addEventListener('wheel', function (event) {
      if (!lightbox.isOpen) return;
      event.preventDefault();
      setLightboxScale(
        lightbox.scale + (event.deltaY < 0 ? 0.5 : -0.5),
        event.clientX,
        event.clientY,
        true
      );
    }, { passive: false });

    stage.addEventListener('pointerdown', onLightboxPointerDown);
    stage.addEventListener('pointermove', onLightboxPointerMove);
    stage.addEventListener('pointerup', onLightboxPointerUp);
    stage.addEventListener('pointercancel', onLightboxPointerUp);

    // Evita que manejadores globales del tema interpreten clics dentro del visor.
    root.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  function collectLightboxItems(section, selectedWrapper) {
    var wrappers = section.querySelectorAll('[data-bo-lightbox-item]');
    var items = [];
    var selectedMediaId = selectedWrapper.getAttribute('data-media-id');
    var selectedIndex = 0;
    var seen = {};

    for (var i = 0; i < wrappers.length; i += 1) {
      var wrapper = wrappers[i];
      var mediaId = wrapper.getAttribute('data-media-id') || String(i);
      var fullImage = wrapper.getAttribute('data-bo-full-image');

      if (!fullImage || seen[mediaId]) continue;
      seen[mediaId] = true;

      if (mediaId === selectedMediaId) selectedIndex = items.length;

      items.push({
        src: fullImage,
        alt: wrapper.getAttribute('data-bo-image-alt') || '',
        mediaId: mediaId
      });
    }

    return { items: items, index: selectedIndex };
  }

  function openLightbox(wrapper, trigger) {
    var section = wrapper.closest('[data-section-type="product-template"]');
    if (!section) return;

    var collected = collectLightboxItems(section, wrapper);
    if (!collected.items.length) return;

    buildLightbox();

    lightbox.items = collected.items;
    lightbox.index = collected.index;
    lightbox.trigger = trigger || null;
    lightbox.isOpen = true;

    document.body.classList.add('bo-lightbox-open');
    lightbox.root.hidden = false;
    lightbox.root.setAttribute('aria-hidden', 'false');

    showLightboxItem(lightbox.index);

    window.requestAnimationFrame(function () {
      lightbox.closeButton.focus();
    });
  }

  function closeLightbox() {
    if (!lightbox.root || !lightbox.isOpen) return;

    lightbox.isOpen = false;
    lightbox.root.hidden = true;
    lightbox.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bo-lightbox-open');
    resetLightboxZoom();

    if (lightbox.trigger && typeof lightbox.trigger.focus === 'function') {
      try {
        lightbox.trigger.focus({ preventScroll: true });
      } catch (error) {
        lightbox.trigger.focus();
      }
    }
  }

  function normalizeLightboxIndex(index) {
    var length = lightbox.items.length;
    if (!length) return 0;
    return ((index % length) + length) % length;
  }

  function showLightboxItem(index) {
    if (!lightbox.items.length) return;

    lightbox.index = normalizeLightboxIndex(index);
    resetLightboxZoom();

    var item = lightbox.items[lightbox.index];
    lightbox.image.classList.add('is-loading');
    lightbox.image.alt = item.alt;
    lightbox.image.src = item.src;
    lightbox.counter.textContent = (lightbox.index + 1) + ' / ' + lightbox.items.length;

    var singleImage = lightbox.items.length < 2;
    lightbox.previousButton.disabled = singleImage;
    lightbox.nextButton.disabled = singleImage;
  }

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function getStageRect() {
    return lightbox.stage ? lightbox.stage.getBoundingClientRect() : null;
  }

  function clampLightboxTranslation() {
    if (!lightbox.stage || !lightbox.image || lightbox.scale <= 1) {
      lightbox.translateX = 0;
      lightbox.translateY = 0;
      return;
    }

    var baseWidth = lightbox.image.offsetWidth || 0;
    var baseHeight = lightbox.image.offsetHeight || 0;
    var stageWidth = lightbox.stage.clientWidth || 0;
    var stageHeight = lightbox.stage.clientHeight || 0;

    if (!baseWidth || !baseHeight || !stageWidth || !stageHeight) return;

    var maxX = Math.max(0, (baseWidth * lightbox.scale - stageWidth) / 2);
    var maxY = Math.max(0, (baseHeight * lightbox.scale - stageHeight) / 2);

    lightbox.translateX = clamp(lightbox.translateX, -maxX, maxX);
    lightbox.translateY = clamp(lightbox.translateY, -maxY, maxY);
  }

  function setLightboxScale(nextScale, focalClientX, focalClientY, snapToHalf) {
    if (!lightbox.stage) return;

    var previousScale = lightbox.scale;
    var targetScale = snapToHalf
      ? Math.round(nextScale * 2) / 2
      : nextScale;

    targetScale = clamp(targetScale, 1, 5);

    var stageRect = getStageRect();
    if (!stageRect) return;

    var focalX = typeof focalClientX === 'number'
      ? focalClientX - stageRect.left
      : stageRect.width / 2;
    var focalY = typeof focalClientY === 'number'
      ? focalClientY - stageRect.top
      : stageRect.height / 2;

    var currentCenterX = stageRect.width / 2 + lightbox.translateX;
    var currentCenterY = stageRect.height / 2 + lightbox.translateY;
    var localX = (focalX - currentCenterX) / previousScale;
    var localY = (focalY - currentCenterY) / previousScale;

    lightbox.scale = targetScale;

    if (targetScale <= 1) {
      lightbox.translateX = 0;
      lightbox.translateY = 0;
    } else {
      lightbox.translateX = focalX - localX * targetScale - stageRect.width / 2;
      lightbox.translateY = focalY - localY * targetScale - stageRect.height / 2;
    }

    clampLightboxTranslation();
    applyLightboxTransform();
  }

  function resetLightboxZoom() {
    lightbox.scale = 1;
    lightbox.translateX = 0;
    lightbox.translateY = 0;
    lightbox.pointers = {};
    lightbox.gesture = null;

    if (lightbox.image) {
      lightbox.image.classList.remove('is-dragging', 'is-gesturing');
    }

    applyLightboxTransform();
  }

  function applyLightboxTransform() {
    if (!lightbox.image) return;

    clampLightboxTranslation();

    lightbox.image.style.transform =
      'translate3d(calc(-50% + ' + lightbox.translateX + 'px), calc(-50% + ' +
      lightbox.translateY + 'px), 0) scale(' + lightbox.scale + ')';

    lightbox.image.classList.toggle('is-zoomed', lightbox.scale > 1);

    if (lightbox.zoomOutButton) lightbox.zoomOutButton.disabled = lightbox.scale <= 1;
    if (lightbox.zoomInButton) lightbox.zoomInButton.disabled = lightbox.scale >= 5;
  }

  function getActivePointers() {
    var points = [];
    for (var id in lightbox.pointers) {
      if (Object.prototype.hasOwnProperty.call(lightbox.pointers, id)) {
        points.push(lightbox.pointers[id]);
      }
    }
    return points;
  }

  function pointerDistance(first, second) {
    var x = second.x - first.x;
    var y = second.y - first.y;
    return Math.sqrt(x * x + y * y);
  }

  function beginLightboxDrag(point) {
    lightbox.gesture = {
      type: 'drag',
      id: point.id,
      startX: point.x,
      startY: point.y,
      originX: lightbox.translateX,
      originY: lightbox.translateY,
      moved: false
    };
  }

  function beginLightboxPinch() {
    var points = getActivePointers();
    if (points.length < 2) return;

    var first = points[0];
    var second = points[1];
    var stageRect = getStageRect();
    if (!stageRect) return;

    var midpointX = (first.x + second.x) / 2 - stageRect.left;
    var midpointY = (first.y + second.y) / 2 - stageRect.top;
    var centerX = stageRect.width / 2 + lightbox.translateX;
    var centerY = stageRect.height / 2 + lightbox.translateY;

    lightbox.gesture = {
      type: 'pinch',
      startDistance: Math.max(1, pointerDistance(first, second)),
      startScale: lightbox.scale,
      localFocusX: (midpointX - centerX) / lightbox.scale,
      localFocusY: (midpointY - centerY) / lightbox.scale,
      moved: true
    };

    lightbox.image.classList.add('is-dragging', 'is-gesturing');
  }

  function onLightboxPointerDown(event) {
    if (!lightbox.isOpen || (event.pointerType === 'mouse' && event.button > 0)) return;

    event.preventDefault();

    lightbox.pointers[event.pointerId] = {
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY
    };

    try {
      lightbox.stage.setPointerCapture(event.pointerId);
    } catch (error) {
      // Algunos navegadores antiguos no implementan captura de puntero.
    }

    var points = getActivePointers();
    if (points.length >= 2) {
      beginLightboxPinch();
    } else {
      beginLightboxDrag(points[0]);
      if (lightbox.scale > 1) lightbox.image.classList.add('is-dragging');
    }
  }

  function onLightboxPointerMove(event) {
    var stored = lightbox.pointers[event.pointerId];
    if (!stored) return;

    stored.x = event.clientX;
    stored.y = event.clientY;

    var points = getActivePointers();

    if (points.length >= 2) {
      event.preventDefault();

      if (!lightbox.gesture || lightbox.gesture.type !== 'pinch') {
        beginLightboxPinch();
      }

      var first = points[0];
      var second = points[1];
      var gesture = lightbox.gesture;
      var stageRect = getStageRect();
      if (!gesture || !stageRect) return;

      var distance = Math.max(1, pointerDistance(first, second));
      var nextScale = clamp(
        gesture.startScale * distance / gesture.startDistance,
        1,
        5
      );
      var midpointX = (first.x + second.x) / 2 - stageRect.left;
      var midpointY = (first.y + second.y) / 2 - stageRect.top;

      lightbox.scale = nextScale;
      lightbox.translateX = midpointX - gesture.localFocusX * nextScale - stageRect.width / 2;
      lightbox.translateY = midpointY - gesture.localFocusY * nextScale - stageRect.height / 2;
      clampLightboxTranslation();
      applyLightboxTransform();
      return;
    }

    var drag = lightbox.gesture;
    if (!drag || drag.type !== 'drag' || drag.id !== event.pointerId) return;

    var deltaX = event.clientX - drag.startX;
    var deltaY = event.clientY - drag.startY;

    if (Math.abs(deltaX) > 5 || Math.abs(deltaY) > 5) drag.moved = true;

    if (lightbox.scale > 1) {
      event.preventDefault();
      lightbox.translateX = drag.originX + deltaX;
      lightbox.translateY = drag.originY + deltaY;
      clampLightboxTranslation();
      applyLightboxTransform();
    }
  }

  function onLightboxPointerUp(event) {
    var stored = lightbox.pointers[event.pointerId];
    if (!stored) return;

    stored.x = event.clientX;
    stored.y = event.clientY;

    var completedGesture = lightbox.gesture;
    var deltaX = completedGesture && completedGesture.type === 'drag'
      ? event.clientX - completedGesture.startX
      : 0;
    var deltaY = completedGesture && completedGesture.type === 'drag'
      ? event.clientY - completedGesture.startY
      : 0;

    delete lightbox.pointers[event.pointerId];

    try {
      lightbox.stage.releasePointerCapture(event.pointerId);
    } catch (error) {
      // La captura puede haberse liberado automáticamente.
    }

    var remaining = getActivePointers();

    if (remaining.length >= 2) {
      beginLightboxPinch();
      return;
    }

    if (remaining.length === 1) {
      beginLightboxDrag(remaining[0]);
      lightbox.image.classList.toggle('is-dragging', lightbox.scale > 1);
      lightbox.image.classList.remove('is-gesturing');
      return;
    }

    lightbox.image.classList.remove('is-dragging', 'is-gesturing');

    if (
      completedGesture &&
      completedGesture.type === 'drag' &&
      lightbox.scale === 1 &&
      lightbox.items.length > 1 &&
      Math.abs(deltaX) > 55 &&
      Math.abs(deltaX) > Math.abs(deltaY) * 1.2
    ) {
      showLightboxItem(lightbox.index + (deltaX < 0 ? 1 : -1));
    }

    lightbox.gesture = null;
  }

  function onDocumentKeydown(event) {
    if (!lightbox.isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeLightbox();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showLightboxItem(lightbox.index - 1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      showLightboxItem(lightbox.index + 1);
    } else if (event.key === '+' || event.key === '=') {
      event.preventDefault();
      setLightboxScale(lightbox.scale + 0.5);
    } else if (event.key === '-' || event.key === '_') {
      event.preventDefault();
      setLightboxScale(lightbox.scale - 0.5);
    }
  }

  function findMainProductImage(target) {
    if (!target || !target.closest) return null;

    var image = target.closest('img.product--image');
    if (!image) return null;

    var wrapper = image.closest('[data-bo-lightbox-item]');
    if (!wrapper) return null;

    return { image: image, wrapper: wrapper };
  }

  function onGalleryPointerDown(event) {
    var match = findMainProductImage(event.target);
    if (!match || event.button > 0) return;

    galleryGesture = {
      id: event.pointerId,
      image: match.image,
      startX: event.clientX,
      startY: event.clientY,
      moved: false
    };
  }

  function onGalleryPointerMove(event) {
    if (!galleryGesture || galleryGesture.id !== event.pointerId) return;

    if (
      Math.abs(event.clientX - galleryGesture.startX) > 8 ||
      Math.abs(event.clientY - galleryGesture.startY) > 8
    ) {
      galleryGesture.moved = true;
    }
  }

  function onGalleryPointerEnd(event) {
    if (!galleryGesture || galleryGesture.id !== event.pointerId) return;

    // El evento click se dispara justo después de pointerup. Se limpia después.
    window.setTimeout(function () {
      galleryGesture = null;
    }, 80);
  }

  function onGalleryImageClick(event) {
    var match = findMainProductImage(event.target);
    if (!match) return;

    if (galleryGesture && galleryGesture.image === match.image && galleryGesture.moved) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    openLightbox(match.wrapper, match.image);
  }

  function onReady() {
    // Debutify termina primero su inicialización y después aplicamos la orientación.
    scheduleInit(80);
    window.setTimeout(initAllProductSections, 350);
    window.setTimeout(initAllProductSections, 900);

    document.addEventListener('pointerdown', onGalleryPointerDown, true);
    document.addEventListener('pointermove', onGalleryPointerMove, true);
    document.addEventListener('pointerup', onGalleryPointerEnd, true);
    document.addEventListener('pointercancel', onGalleryPointerEnd, true);
    document.addEventListener('click', onGalleryImageClick, true);
    document.addEventListener('keydown', onDocumentKeydown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(initAllProductSections, RESIZE_DELAY);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-section-type="product-template"]')
      : null;

    if (section) {
      window.setTimeout(function () {
        initProductSection(section);
      }, 80);
    } else {
      scheduleInit(100);
    }
  });

  document.addEventListener('shopify:block:select', function () {
    scheduleInit(80);
  });
})(window, document);
